import { render, staticRenderFns } from "./PageCreatorsList.vue?vue&type=template&id=5903312a&scoped=true&"
import script from "./PageCreatorsList.vue?vue&type=script&lang=ts&"
export * from "./PageCreatorsList.vue?vue&type=script&lang=ts&"
import style0 from "./PageCreatorsList.vue?vue&type=style&index=0&id=5903312a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903312a",
  null
  
)

export default component.exports